import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '../../components/Boneyard';

const propTypes = {
  raidersTermsAndConditionsHeader: PropTypes.string,
  raidersTermsAndConditionsContent: PropTypes.string,
  automationHook: PropTypes.string,
};

const defaultProps = {
  raidersTermsAndConditionsHeader: 'Terms and Conditions',
  raidersTermsAndConditionsContent:
    'All sales are final. No Refunds. No Cancellations. No changes, additions or modifications permitted after booking. You may not buy more raiders tickets than the number of passengers. Customer needs to provide and email address for the primary ticket holder that is associated with their TicketMaster account, or the email they will use to create their TicketMaster account. In order to purchase Raiders tickets through Allegiant, you must purchase a Round-Trip flight and a Hotel( 2 night minimum stay). Flight window must bracket game date. LAS is the only destination permitted. Seats will be assigned at time of purchase within the selected seating tier. Raiders Tickets offered via Allegiant website will have only regular seat available and Accessible Seating will not be available. For Accessible Seating please visit allegiantstadium.com. In case of a flight delay or a cancellation , which would make it impossible to attend the selected Raiders game, customers will be entitled to a full package refund - through Call Center Only.',
};

const TermsAndConditions = ({
  raidersTermsAndConditionsHeader,
  raidersTermsAndConditionsContent,
  automationHook,
}) => (
  <Box automationHook={automationHook}>
    <Text size={12} color="#ffffff" weight={700}>
      {raidersTermsAndConditionsHeader}
    </Text>
    <Text size={12} color="#ffffff">
      {raidersTermsAndConditionsContent}
    </Text>
  </Box>
);

TermsAndConditions.propTypes = propTypes;
TermsAndConditions.defaultProps = defaultProps;

export default TermsAndConditions;
